import { storeStructure } from '../store/reducers';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { createOriginOutputs, removeOriginOutputs } from '../store/actions/originOutputsActions';
import { createOriginOutput, removeOriginOutput } from '../store/externalCalls/api/originOutput';

export default {
  apiCreate: createOriginOutput,
  actionCreate: createOriginOutputs,
  apiRemove: removeOriginOutput,
  actionRemove: removeOriginOutputs,
  attributeName: storeStructure.OriginOutputs,
  storeNode: storeStructure.OriginOutputs,
  canOpen: false,
  canEdit: false,
  canCreate: true,
  canRemove: true,
  emptyMessage: "You don't have any Origin files for this vod.",
  fields: [
    {
      attributeName: 'name',
      label: 'Origin Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canEdit: true,
      canCreate: true,
      required:true,
      helpText: 'Name of the output',
      width: '12rem',
    },
    {
      attributeName: 'outputFile',
      label: 'Output File Url',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '20rem',
      default: '',
      canEdit: true,
      canCreate: true,
      required: true,
      helpText: 'Url of the output file',
    },
  ],
};
